/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Filter_Outside_PreInputs */



/**
* | output |
* | --- |
* | "Fresh air pre-filter" |
*
* @param {Air_Handler_Unit_Filter_Outside_PreInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_filter_outside_pre = /** @type {((inputs?: Air_Handler_Unit_Filter_Outside_PreInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Filter_Outside_PreInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Fresh air pre-filter")
	return /** @type {LocalizedString} */ ("Préfiltre d'air neuf")
});